import { CurrencyCentInput, FF, FieldSet, Hr, IconSize, Info, Select, TextMask, Validators } from 'ui/components'
import { Col, FormRow, Row } from 'ui/themes/globalStyles'

import { useAnnualReviewSalesDepositsContext } from '../../context/AnnualReviewSalesDepositsContext'

export const RelationshipDetails = () => {
  const { formApi, data, id } = useAnnualReviewSalesDepositsContext()

  return (
    <FieldSet legend="Relationship Details">
      <Row>
        <Col>
          {data.bankAccountNumber && (
            <Info label="Bank Account">
              <TextMask isBankAccount text={data.bankAccountNumber} iconSize={IconSize.XS} />
            </Info>
          )}
        </Col>
        <Col>
          <Info label="Sales & Deposit Summary Number">SDS-{id}</Info>
        </Col>
      </Row>
      <Row>
        <Col>
          <Info label="Customer Name">{data.customerNameLabel || '---'}</Info>
        </Col>
        <Col>
          <Info label="Annual Review">{data.annualReviewLabel}</Info>
        </Col>
      </Row>
      <FormRow>
        <Col>
          <formApi.Field
            name="status"
            children={(field) => (
              <FF field={field} input={(p) => <Select {...p} data={data.availableStatuses} />} label="Status" />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name="totalFinancials"
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Total Revenue From Financials" />
            )}
          />
        </Col>
      </FormRow>
      <br />
      <Hr />
    </FieldSet>
  )
}
